import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronRightSquareOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path d="M12.32 7.998 9.826 5.504l-.99.99 1.505 1.504-1.505 1.505.99.99z" fill="currentColor" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8 .5C1.438.5.5 1.438.5 8s.938 7.5 7.5 7.5 7.5-.937 7.5-7.5S14.563.5 8 .5M2.125 4.319C1.96 5.192 1.9 6.37 1.9 8s.06 2.808.225 3.681c.162.86.4 1.287.654 1.54.253.253.68.492 1.54.654q.434.082.98.132V1.993a11 11 0 0 0-.98.132c-.86.162-1.287.4-1.54.654-.253.253-.492.68-.654 1.54M8 14.1q-.704 0-1.302-.016V1.916A47 47 0 0 1 8 1.9c1.63 0 2.808.06 3.681.225.86.162 1.287.4 1.54.654.253.253.492.68.654 1.54.165.873.225 2.051.225 3.681s-.06 2.808-.225 3.681c-.162.86-.4 1.287-.654 1.54-.253.253-.68.492-1.54.654-.873.165-2.051.225-3.681.225"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
ChevronRightSquareOutlinedSize16Glyph.displayName = 'ChevronRightSquareOutlinedSize16Glyph';
